const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4wMDQ4IDAuNTI4NjI1TDExLjk0NzYgMS40NzE0M0w2LjE0Mjg3IDcuMjc2MTdMMC4zMzgxMzUgMS40NzE0M0wxLjI4MDk0IDAuNTI4NjI1TDYuMTQyODcgNS4zOTA1NkwxMS4wMDQ4IDAuNTI4NjI1WiIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=chevron_down-5a020270.mjs.map
